import { ThemeOptions } from "@mui/material";
import { typographyVariants } from "../constants";

export const muiFormHelperText: ThemeOptions["components"] = {
  MuiFormHelperText: {
    styleOverrides: {
      root: {
        ...typographyVariants.small,
        marginLeft: 0,
      },
    },
  },
};
